export default "__VITE_ASSET__CVp4We$G__"